module.exports = __webpack_public_path__ + "static/media/praia-de-pipa-rn.e46787af.jpg";